export type OpportuniteType = "job" | "funding" | "appel";

export interface Opportunite {
  id: string;
  type: OpportuniteType;
  title: string;
  organization: string;
  logo: string;
  country: string;
  countryFlag: string;
  sector: string;
  deadline: string;
  amount?: string;
  description: string;
  link: string;
  featured?: boolean;
  remote?: boolean;
}

export const opportunites: Opportunite[] = [
  {
    id: "opp-1",
    type: "funding",
    title: "Tony Elumelu Foundation Entrepreneurship Programme 2026",
    organization: "Tony Elumelu Foundation",
    logo: "https://public.readdy.ai/ai/img_res/7a29d4389819ff37f23c29afeec635da.jpg",
    country: "Pan-Africain",
    countryFlag: "🌍",
    sector: "Tous secteurs",
    deadline: "2026-05-31",
    amount: "5 000 USD",
    description: "Le programme phare de la TEF offre 5 000 USD de seed capital, du mentorat et une formation à 1 000 entrepreneurs africains chaque année.",
    link: "https://www.tonyelumelufoundation.org",
    featured: true,
  },
  {
    id: "opp-2",
    type: "funding",
    title: "Appel à projets Afrique Verte — Énergie Renouvelable",
    organization: "African Development Bank",
    logo: "https://readdy.ai/api/search-image?query=african%20development%20bank%20logo%20minimal%20clean%20green%20professional%20brand%20identity%20modern&width=80&height=80&seq=logo2&orientation=squarish",
    country: "Pan-Africain",
    countryFlag: "🌍",
    sector: "Énergie",
    deadline: "2026-06-15",
    amount: "50 000 – 500 000 USD",
    description: "La BAD finance des projets d'énergie renouvelable en Afrique subsaharienne. Subventions et prêts concessionnels disponibles pour les PME du secteur.",
    link: "https://www.afdb.org",
    featured: true,
  },
  {
    id: "opp-3",
    type: "job",
    title: "Product Manager — Fintech (Remote Africa)",
    organization: "Flutterwave",
    logo: "https://readdy.ai/api/search-image?query=fintech%20startup%20logo%20minimal%20clean%20orange%20modern%20brand%20identity%20professional&width=80&height=80&seq=logo3&orientation=squarish",
    country: "Nigeria",
    countryFlag: "🇳🇬",
    sector: "Fintech",
    deadline: "2026-05-20",
    description: "Flutterwave recrute un Product Manager expérimenté pour piloter le développement de nouveaux produits de paiement en Afrique de l'Ouest.",
    link: "https://flutterwave.com/careers",
    remote: true,
  },
  {
    id: "opp-4",
    type: "appel",
    title: "Appel à candidatures — Africa Tech Summit Nairobi 2026",
    organization: "Africa Tech Summit",
    logo: "https://readdy.ai/api/search-image?query=tech%20summit%20conference%20logo%20minimal%20clean%20blue%20modern%20brand%20identity%20professional&width=80&height=80&seq=logo4&orientation=squarish",
    country: "Kenya",
    countryFlag: "🇰🇪",
    sector: "Tech",
    deadline: "2026-05-10",
    description: "Soumettez votre startup pour pitcher devant 500 investisseurs et partenaires lors du plus grand sommet tech d'Afrique de l'Est.",
    link: "https://www.africatechsummit.com",
  },
  {
    id: "opp-5",
    type: "job",
    title: "Data Scientist — AgriTech (Dakar)",
    organization: "Wave Mobile Money",
    logo: "https://readdy.ai/api/search-image?query=mobile%20money%20fintech%20logo%20minimal%20clean%20teal%20modern%20brand%20identity%20professional&width=80&height=80&seq=logo5&orientation=squarish",
    country: "Sénégal",
    countryFlag: "🇸🇳",
    sector: "Fintech",
    deadline: "2026-05-25",
    description: "Wave recherche un Data Scientist pour analyser les comportements de paiement et améliorer les modèles de scoring crédit en Afrique de l'Ouest.",
    link: "https://wave.com/careers",
    remote: false,
  },
  {
    id: "opp-6",
    type: "funding",
    title: "Google for Startups Africa Fund — Cycle 2026",
    organization: "Google for Startups",
    logo: "https://readdy.ai/api/search-image?query=google%20startup%20fund%20logo%20minimal%20clean%20colorful%20modern%20brand%20identity%20professional&width=80&height=80&seq=logo6&orientation=squarish",
    country: "Pan-Africain",
    countryFlag: "🌍",
    sector: "Tech",
    deadline: "2026-06-30",
    amount: "Jusqu'à 100 000 USD",
    description: "Google offre des crédits cloud, du mentorat et un accès à son réseau mondial aux startups africaines en phase de croissance.",
    link: "https://startup.google.com",
  },
  {
    id: "opp-7",
    type: "appel",
    title: "Prix de l'Innovation Africaine — GSMA Mobile for Development",
    organization: "GSMA",
    logo: "https://readdy.ai/api/search-image?query=GSMA%20mobile%20innovation%20award%20logo%20minimal%20clean%20modern%20brand%20identity%20professional&width=80&height=80&seq=logo7&orientation=squarish",
    country: "Pan-Africain",
    countryFlag: "🌍",
    sector: "Tech",
    deadline: "2026-05-15",
    amount: "25 000 USD",
    description: "Récompense les solutions mobiles innovantes ayant un impact social mesurable en Afrique subsaharienne.",
    link: "https://www.gsma.com",
  },
  {
    id: "opp-8",
    type: "job",
    title: "Growth Marketing Manager — E-commerce (Abidjan)",
    organization: "Jumia",
    logo: "https://readdy.ai/api/search-image?query=ecommerce%20africa%20marketplace%20logo%20minimal%20clean%20orange%20modern%20brand%20identity%20professional&width=80&height=80&seq=logo8&orientation=squarish",
    country: "Côte d'Ivoire",
    countryFlag: "🇨🇮",
    sector: "Commerce",
    deadline: "2026-05-18",
    description: "Jumia recrute un Growth Marketing Manager pour accélérer l'acquisition client et la rétention sur le marché ivoirien.",
    link: "https://group.jumia.com/careers",
    remote: false,
  },
];
